import type { Handleiding } from './soort';

export const ar: Handleiding = {
  code: 'ar',
  titel: 'الدليل',
  inleiding:
    'يترجم Ask Gio Tolk محادثة بين شخصين لا يتكلمان اللغة نفسها. في الأسفل شرح لما يفعله كل زر.',
  knop: 'افتح الدليل',
  sluiten: 'إغلاق',
  groepGebruik: 'المشاركة في الحديث',
  groepBeheer: 'الإعداد والإدارة',
  delen: [
    {
      titel: 'التحدّث',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'تكلّم',
          uitleg:
            'انقر مرة واحدة للبدء. يتوقّف التسجيل من تلقاء نفسه بمجرد أن تصمت لأكثر من ثانية بقليل، أو إذا نقرت مرة أخرى. وبعد دقيقة يتوقّف على أي حال.',
        },
        {
          kop: 'صوت واحد في كل مرة',
          uitleg:
            'ما دام التطبيق يتكلّم، لا يمكنك التسجيل. وما دمت تسجّل، تنتظر الترجمة الواردة حتى تنتهي. وإلا سجّل الميكروفون صوت التطبيق وظنّ أنك أنت من قال ذلك.',
        },
        {
          kop: 'اكتب رسالتك هنا',
          uitleg:
            'يعمل إلى جانب الكلام ويمرّ بالترجمة نفسها. زر الإدخال يُرسل، وزر العالي مع الإدخال يبدأ سطراً جديداً.',
        },
        {
          kop: 'وقت للتصحيح',
          uitleg:
            'هنا تحدّد كم ثانية لديك لمراجعة جملتك المكتوبة قبل أن تُرسل. عند الصفر تُرسل فوراً.',
        },
        {
          kop: 'راجع وأرسل بنفسك دائماً',
          uitleg: 'لا ساعة بعد الآن. كل جملة تنتظر حتى تضغط على إرسال. لمن يريد مراجعة كل جملة.',
        },
        {
          kop: 'تشغيل الترجمة فوراً',
          uitleg: 'مفعّل. أوقفه إذا كنت تفضّل القراءة أولاً وأن تقرّر بنفسك متى تستمع.',
        },
      ],
    },
    {
      titel: 'قراءة الرسائل',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'ما يظهر بخط كبير',
          uitleg:
            'ما هو بلغتك أنت يظهر بخط كبير. في جملتك أنت يكون ذلك نصّك الأصلي، لتتحقّق من أن التطبيق فهمك جيداً. وفي جملة الطرف الآخر تكون الترجمة.',
        },
        {
          kop: 'فتح الأصل أو الترجمة',
          uitleg: 'اللغة الأخرى تحتها، مطويّة. انقر على السطر لفتحها.',
        },
        {
          kop: 'المثلث الصغير',
          uitleg: 'يعيد تشغيل الترجمة.',
        },
        {
          kop: 'الرأس المتكلّم',
          uitleg:
            'يشغّل تسجيل الطرف الآخر نفسه. لا يظهر إلا في رسالة منطوقة وفقط إذا كان «أرسل صوتك أيضاً» مفعّلاً. الرسالة المكتوبة ليس لها تسجيل.',
        },
      ],
    },
    {
      titel: 'الأزرار في أعلى الشاشة',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'ناقص وزائد',
          uitleg: 'يصغّر النص أو يكبّره. على خمس درجات، ويبقى محفوظاً.',
        },
        {
          kop: 'الميكروفون',
          uitleg: 'يخفي زر التحدّث إذا كنت تكتب فقط. هذا يوفّر مساحة.',
        },
        {
          kop: 'لوحة المفاتيح',
          uitleg: 'تخفي حقل النص. يبقى دائماً واحد من الاثنين مفعّلاً، وإلا لما استطعت قول أي شيء.',
        },
      ],
    },
    {
      titel: 'الدخول',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'ما اللغة التي تتكلّمها',
          uitleg:
            'هذا الاختيار يحدّد أيضاً لغة الأزرار والرسائل. فكلٌّ منكما يرى شاشة مختلفة، وهذا هو المقصود.',
        },
        {
          kop: 'صوتك في الترجمة',
          uitleg:
            'اختر إن كنت تبدو رجلاً أم امرأة. هذا يخصّك أنت، لا الغرفة: كل مشارك يختار على حدة.',
        },
        {
          kop: 'الإذن باستخدام الميكروفون',
          uitleg:
            'يطلبه المتصفح عند الدخول. إذا رفضت، يمكنك الكتابة على أي حال. ويمكنك منح الإذن لاحقاً من القفل في شريط العنوان.',
        },
      ],
    },
    {
      titel: 'في الأسفل، مطويّ',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'قائمة كلمات احتياطية',
          uitleg:
            'كلمات يجب أن تُترجم دائماً بالطريقة نفسها: الأسماء والمصطلحات المهنية والعلامات التجارية. تسري على الغرفة كلها.',
        },
        {
          kop: 'تعديل الإعدادات',
          uitleg:
            'اللغة والصوت والنبرة وتصحيح الإملاء يمكن تغييرها أيضاً في منتصف الحديث. وما تغيّره هنا يسري فوراً على الاثنين.',
        },
      ],
    },
    {
      titel: 'بدء محادثة',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'اسم المحادثة',
          uitleg: 'يمكن أن يبقى فارغاً. لا يظهر إلا في أعلى شاشتك، لتعرف مع من تتحدّث.',
        },
        {
          kop: 'المتحدّث ١ والمتحدّث ٢',
          uitleg:
            'لغتا هذه المحادثة. من يدخل أولاً يأخذ المكان الأول. ويمكنك تبديل اللغتين لاحقاً.',
        },
        {
          kop: 'نبرة الترجمة',
          uitleg:
            'على اليمين تختار المخاطبة الودّية أو الرسمية، وعلى اليسار الأجواء: محايدة أو ودّية أو عملية أو رسمية أو بين شريكين. بدون توجيه يختار النموذج الصيغة الرسمية في أغلب الأحيان، وهذا يبدو متحفّظاً في حديث عادي.',
        },
        {
          kop: 'أرسل صوتك أيضاً',
          uitleg:
            'يمكن للطرف الآخر أن يسمع تسجيلك إلى جانب الترجمة. مفيد لتعلّم لغة. أوقفه في حديث حسّاس: من يستلم التسجيل يمكنه الاحتفاظ به.',
        },
        {
          kop: 'صحّح الأخطاء الإملائية في نصّك',
          uitleg:
            'مفعّل. أوقفه لترى ما فهمه النموذج فعلاً. فإذا ظهرت جملة غريبة، عرفت إن كانت قد فُهمت خطأً أم فُهمت جيداً ثم صُقلت.',
        },
        {
          kop: 'مع رمز سرّي',
          uitleg:
            'أبلغ الرمز شفهياً، لا في الرسالة نفسها مع الرابط. هذا يحمي من رابط يُعاد توجيهه.',
        },
        {
          kop: 'رمز الاستجابة السريعة',
          uitleg:
            'دع الطرف الآخر يمسحه، أو أرسل الرابط. تنتهي صلاحية الغرفة تلقائياً بعد أربع ساعات.',
        },
      ],
    },
    {
      titel: 'ماذا يحدث لمحادثتك',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'النص لا يُحفظ',
          uitleg: 'ما تقولانه لا يدخل قاعدة البيانات. فقط متى وكم جرى الحديث، من أجل التكاليف.',
        },
        {
          kop: 'التسجيلات تختفي من تلقاء نفسها',
          uitleg: 'يبقى الصوت عشر دقائق في الذاكرة ثم يزول.',
        },
        {
          kop: 'الغرفة تنتهي صلاحيتها',
          uitleg: 'بعد أربع ساعات من إنشائها. بعد ذلك يتوقّف الرابط عن العمل.',
        },
        {
          kop: 'هناك ميزانية',
          uitleg:
            'لكل غرفة ولكل شهر. إذا امتلأت، يتوقّف التطبيق عن الترجمة ويقول ذلك. وهذا ليس عطلاً.',
        },
      ],
    },
  ],
};
